import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { DropMenuEl } from "common/components/drop-menu";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement } from "common/components/tooltip/types";
import { ButtonTheme } from "common/components/button/constants";
import { InsightsFormulaEditorEl } from "../insights-formula-editor/index";
export function template() {
  const { formula, open } = this.state;
  const { label: formulaLabel, value } = formula;
  const error = this.attr(`error`);
  const label = [formulaLabel || value, formulaLabel && ` (${value})`].join(``);
  const Display = () => /* @__PURE__ */ jsx("div", {
    sel: ".display-wrapper"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".truncated",
    attrs: {
      theme: this.attr(`theme`),
      type: error ? this.helpers.ButtonType.Destructive : this.helpers.ButtonType.Info,
      pressed: open
    },
    on: {
      click: this.helpers.handleLabelClick
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".formula-clause-description"
  }, /* @__PURE__ */ jsx("span", {
    sel: ".formula-clause-label",
    class: { "invalid-formula": !!error }
  }, label))), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".formula-clause-remove",
    attrs: {
      theme: ButtonTheme.Tertiary,
      type: this.helpers.ButtonType.Destructive,
      icon: `x`
    },
    on: {
      click: this.helpers.handleRemoveClick
    }
  }));
  return /* @__PURE__ */ jsx("div", {
    sel: ".formula-clause-container"
  }, /* @__PURE__ */ jsx(Display, null), open && /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open
    },
    on: {
      change: this.helpers.handleMenuChange
    }
  }, /* @__PURE__ */ jsx(InsightsFormulaEditorEl, {
    props: { label: formulaLabel, value },
    on: {
      save: this.helpers.handleSave
    }
  })), error ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      "always-show": true,
      "max-width": `250px`,
      placement: Placement.Right,
      type: DisplayType.Error
    }
  }, error) : null);
}
